'use client';

import { useCallback } from 'react';
import { useTranslations } from 'next-intl';

import { ConfirmDialog } from '@/components/ui/ConfirmDialog';
import { useSystemDialogStore } from '@/lib/stores/system-dialog-store';

export function SystemDialogHost() {
  const commonT = useTranslations('common');
  const activeDialog = useSystemDialogStore((state) => state.activeDialog);
  const resolveActive = useSystemDialogStore((state) => state.resolveActive);

  const handleConfirm = useCallback(() => {
    resolveActive(true);
  }, [resolveActive]);

  const handleCancel = useCallback(() => {
    resolveActive(false);
  }, [resolveActive]);

  return (
    <ConfirmDialog
      isOpen={Boolean(activeDialog)}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      title={activeDialog?.title ?? commonT('confirm')}
      message={activeDialog?.message}
      confirmLabel={activeDialog?.confirmLabel ?? commonT('confirm')}
      cancelLabel={activeDialog?.cancelLabel === undefined ? commonT('cancel') : activeDialog.cancelLabel}
      loadingLabel={commonT('processing')}
      variant={activeDialog?.variant ?? 'default'}
    />
  );
}

export default SystemDialogHost;
